<!-- 项目文件 -->
<template>
    <div class="pl30">
        <div class="baee ">
            <div class=" lh40 bgf6 ">
                <p @click="changeDetail(0)" class="cursor textindent fs16  c000 pl16 disinblock pr25" :class="{'bt':isdetail==0}">驾校详情
                </p>
                <p @click="changeDetail(1)" class="cursor textindent fs16  c000 pl16 disinblock pr25" :class="{'bt':isdetail==1}">驾校信息
                </p>
            </div>
            <p v-if="isdetail==0" class="pl16 pr16 c333 fs14 pt20 pb20 lh26 textindent word-breakno minh200">
              {{Description ||'暂无'}}
            </p>
            <p v-if="isdetail==1" class="pl16 pr16 c333 fs14 pt20 pb20 lh26 textindent word-breakno minh200">
                {{Strength ||'暂无'}}
            </p>
        </div>
        <div class="baee mt20 pb20">
            <div class=" lh40 bgf6 ">
                <p @click="changeBt(0)" class="cursor textindent fs16  c000 pl16 disinblock pr25" :class="{'bt':activeBt==0}">驾校评价</p>
                <p @click="changeBt(1)" class="cursor textindent fs16  c000 pl16 disinblock pr25" :class="{'bt':activeBt==1}">教学评价</p>
            </div>
            <div class="ml16 mr16  pt16 pb16">
                <ul class="">
                    <li @click="changeCommentType(0)" :class="{'bt1':commentType==0}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        全部( {{commentTotal || '0'}} )
                    </li>
                    <li @click="changeCommentType(1)" :class="{'bt1':commentType==1}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        好评( {{commentGood || '0'}} )
                    </li>
                    <li @click="changeCommentType(2)" :class="{'bt1':commentType==2}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        中评( {{commentMid || '0'}} )
                    </li>
                    <li @click="changeCommentType(3)" :class="{'bt1':commentType==3}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        差评( {{commentBad || '0'}} )
                    </li>
                  
                    <li @click="changeCommentType(4)" :class="{'bt1':commentType==4}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        服务质量( {{componenService || '0'}} )
                    </li>
                    <li @click="changeCommentType(5)" :class="{'bt1':commentType==5}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  mr10  c333 fs14 disinblock">
                        教学质量( {{commentTeach || '0'}} )
                    </li>
                    <li v-if="type==0" @click="changeCommentType(6)" :class="{'bt1':commentType==6}" class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  mr10  c333 fs14 disinblock">
                        场地环境( {{commentGround || '0'}} )
                    </li>
                    <li v-if="type==1" @click="changeCommentType(7)" :class="{'bt1':commentType==7}"
                        class="mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        车辆整洁( {{commentCar|| '0'}} )
                    </li>
                    
                    <li @click="changeCommentType(8)" :class="{'bt1':commentType==8}" class=" mt5 cursor pt6 pb6 pr16 pl16 bge8f mr10 ml10  c333 fs14 disinblock">
                        带图评价( {{commentImg || '0'}} )
                    </li>
                </ul>
            </div>
            <div v-if="type==0" class="ml16 mr16  pt16 pb16">
                <div class="mb30 bte8 pt20 " v-for="(item,index) in commentList" :key="index" >
                    <div class="alit">
                        <span>
                            <img class="w40 h40 br50" :src="item.student_image" alt="">
                        </span>
                        <span class="disinblock pr10 lh20">
                            <p class="fs14 c666 "> {{item.phone}} </p>
                            <p class="disinblock">
                                <img v-for="(v,i) in parseInt(item.star)" :key="i" class="w16 h16 mr6" src="../../public/img/img80_1.png" alt="">
                                <img v-if="parseInt(item.star) != item.star" class="w16 h16 mr6" src="../../public/img/img80_3.png" alt="">
                                <img v-if="item.star < 4.1" v-for="(vv,ii) in 5-Math.ceil(item.star)"  class="w16 h16 mr6" src="../../public/img/img80_2.png" alt="">

                            </p>
                        </span>
                    </div>
                    
                    
                    <div class="pl50 mt5 pr50">
                        <p class="fs14 c333 word-breakno ">
                            {{item.content}}
                        </p>
                    
                        <p class="mt10" v-if="item.is_img==0">
                            <span class=" imgb  mr10 fs0" v-for="(v,i) in item.imgs" :key="i">
                                <img class="w100 h50" :preview="index" :src="v" alt="">
                            </span>
                        </p>
                        <div class="pt8 pb8 pl8 pr8 fs14 c333 bradius8 bgF3 mt8 mb8" v-if="item.commentAnswers.length>0">
                           
                            <p v-for="(vv,ii) in item.commentAnswers" :key="ii" class="mt4 mb4">
                                <span class="fs12 c333">
                                    <i class="fs12 c3f8" v-if="vv.comment_people==0">e学e驾</i>
                                    <i class="fs12 c3f8" v-if="vv.comment_people==1">{{Name}}</i>
                            
                                    回复：</span>
                                <span class="fs12 c333 pl2 word-breakno ">
                                    {{vv.answer_content}}
                                </span>
                            </p>
                        </div>
                        <p class="overflow mt10">
                            <span class="fs14 c999 floatl">
                                {{item.create_time_str}}
                            </span>
                            <span class="fs14 c333 floatr">
                                {{item.fabulous_num}} 赞
                            </span>
                        </p>
                    </div>
                </div>

                <div class="textc">
                    <span class="fs18 textc c333 cursor pr10" @click="minPages()"> 上一页 </span>
                    <span class="fs18 textc c333 cursor pl10" @click="addPages()"> 下一页</span>
                </div>
            </div>



            <div v-if="type==1"class="ml16 mr16  pt16 pb16">
                <div class="mb30 bte8 pt20" v-for="(item,index) in teachtList" :key="index" >
                    <div class="alit">
                        <span>
                            <img class="w40 h40 br50" :src="item.student_image || 'https://image.yixueyijia.com/xconline/upload/images/moren.png'" alt="">
                        </span>
                        
                        <span class="disblock w100p overflow pl10 lh20">
                            <p class="fs14 c666 overflow">
                                <span class="fs14 c666">
                                    {{item.phone}}
                                </span>
                                
                                <span class="fs14 c666 pl12">
                                    对<i class="c3f8 fs14">「 {{item.coach_name}} 」</i> 的评论
                                </span>

                                <!--  -->
                            </p>
                            <span class="fs14 c666  pl12 floatr"> 上课时间：{{item.schedule_date_time || '暂无'}} </span>
                            <p class="disinblock">
                                <span class="disinblock pr10 lh20">
                                    <!-- <p class="fs14 c666 "> {{item.phone}} </p> -->
                                    <p class="disinblock">
                                        <img v-for="(v,i) in parseInt(item.star)" :key="i" class="w16 h16 mr6" src="../../public/img/img80_1.png"
                                            alt="">
                                        <img v-if="parseInt(item.star) != item.star" class="w16 h16 mr6" src="../../public/img/img80_3.png" alt="">
                                        <img v-if="item.star < 4.1" v-for="(vv,ii) in 5-Math.ceil(item.star)" class="w16 h16 mr6"
                                            src="../../public/img/img80_2.png" alt="">
                                    </p>
                                </span>
                            </p>
                        </span>
                    </div>
                    
                    
                    <div class="pl50 mt5 pr50">
                        <p class="fs14 c333 word-breakno ">
                            {{item.content}}
                        </p>
                        <p class="mt10" v-if="item.is_img==0">
                            <span class=" imgb  mr10 fs0" v-for="(v,i) in item.imgs" :key="i">
                                <img class="w100 h50" :preview="index" :src="v" alt="">
                            </span>
                        </p>
                        <div class="pt8 pb8 pl8 pr8 fs14 c333 bradius8 bgF3 mt8 mb8" v-if="item.commentAnswers.length>0">
                            <p class="mt5 mb5" v-for="(v,i) in item.commentAnswers" :key="i">
                                <span class="fs12 c333">
                                    <i class="fs12 c3f8" v-if="v.comment_people==0">
                                        e学e驾
                                    </i>
                                    <i class="fs12 c3f8" v-if="v.comment_people==1">
                                    {{Name}}
                                    </i>
                                    回复：</span>
                                <span class="fs12 c333 pl2 word-breakno">
                                    {{v.answer_content}}
                                </span>
                            </p>

                        </div>
                        <p class="overflow mt10">
                            <span class="fs14 c999 floatl">
                                {{item.create_time_str}}
                            </span>
                            <span class="fs14 c333 floatr">
                                {{item.fabulous_num}} 赞
                            </span>
                        </p>
                    </div>
                </div>
                <!-- <div class="fs18 textc c333 cursor" @click="addPages()"> {{loadingtype}}... </div> -->
                <div class="textc">
                    <span class="fs18 textc c333 cursor pr10" @click="minPages()"> 上一页 </span>
                    <span class="fs18 textc c333 cursor pl10" @click="addPages()"> 下一页</span>
                </div>
            </div>

           

            
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: ['Description', 'SchoolId', 'Strength', 'Name'],
        data() {
            return {
                activeBt: 0,
                type: 0,
                commentType: 0,
                pages: 1,

                loadingtype: '点击加载更多',
                commentList: [], //驾校评论列表
                teachtList: [], //教练评论列表
                commentTotal: '', //评论总数
                commentGood: '', //好评
                commentBad: '',
                commentMid: '',
                componenService: '',
                commentGround: '',
                commentTeach: '',
                commentImg: '',
                totalPage: '',
                commentCar: '',
                isdetail: 0
            };
        },
        methods: {
            changeDetail(id) {
                this.isdetail = id;
            },
            changeBt(id) {
                this.commentType = 0
                this.pages = 1
                this.activeBt = id;
                this.type = id;
                this.getComent()
            },
            changeCommentType(id) {
                this.pages = 1
                this.commentType = id;
                this.getComent()
            },
            addPages() {

                if (this.pages >= this.totalPage) {
                    alert('没有更多了')
                    return;
                }
                this.pages++;
                this.getComent()
            },
            minPages() {

                if (this.pages <= 1) {
                    alert('已经是第一页')
                    return;
                }
                this.pages--;
                this.getComent()
            },
            getComent() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/school/getCommentList.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "school_id": that.SchoolId,
                        "type": that.type,
                        "commentType": that.commentType,
                        "page": that.pages,
                        "rows": 5
                    },
                    success: function(data) {
                        that.$previewRefresh();
                        if (that.type == 0) {
                            var arr = []
                            arr = arr.concat(data.obj.schoolComments);
                            console.log(arr)
                            that.commentList = arr
                            that.commentTotal = data.obj.school_total_comment;
                            that.commentGood = data.obj.school_good_comment;
                            that.commentBad = data.obj.school_bad_comment;
                            that.commentMid = data.obj.school_mid_comment;
                            that.componenService = data.obj.school_service_comment;
                            that.commentGround = data.obj.school_ground_comment;
                            that.commentTeach = data.obj.school_quality_comment;
                            that.commentImg = data.obj.have_img_comment;
                            that.totalPage = data.obj.totalPage;
                        } else {
                            var arr = []
                            arr = arr.concat(data.obj.teachComments);
                            console.log(arr)
                            that.teachtList = arr
                            that.commentTotal = data.obj.teach_total_comment;
                            that.commentGood = data.obj.teach_good_comment;
                            that.commentBad = data.obj.teach_bad_comment;
                            that.commentMid = data.obj.teach_mid_comment;
                            that.componenService = data.obj.teach_service_comment;
                            that.commentTeach = data.obj.teach_quality_comment;
                            that.commentImg = data.obj.have_img_comment;
                            that.totalPage = data.obj.totalPage;
                            that.commentCar = data.obj.teach_car_comment;
                        }
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            }
        },
        created() {
            this.getComent()
        },
        mounted() {
            this.$preview.on('imageLoadComplete', (e, item) => {
                let _preview = this.$preview.self;
                let lookUrl = window.location.href + '&look';
                window.history.pushState(null, null, lookUrl);
                _preview.listen('close',
                    function() {
                        if (window.location.href.indexOf('&look') !== -1) {
                            window.history.back();
                        }
                    });
                window.onhashchange = function() {
                    if (_preview !== null && _preview !== undefined) {
                        _preview.close();
                        _preview = null;
                    }
                };
            });
        },
    }
</script>
<style scoped>
    .bt {
        border-bottom: 2px solid #1f82f6;
    }
    
    .imgb {
        border: 3px solid #ededed;
    }
    
    .bt1 {
        background: #1f82f6;
        color: #fff;
    }
</style>